export default __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo_client_white-76e9e1825ab042b5c03227bfcdef9287.png";